<app-base-modal
  [title]="designBlockData().title"
  [showStateToggle]="true"
>
  @if (isLoading) {
    <app-loader/>
  }
  <div
    class="header-modal"
    app-banners-social-header
    [designBlockData]="designBlockData()"
    [columnKey]="modalKey()"
    [isActiveUploadFile]="isActiveUploadFile"
    (uploadFiles)="uploadFiles($event)"
    (handleLoading)="handleLoading($event)"
  ></div>
  @if (!isShowFileLibrary()) {
    <app-carousel
      [itemsCount]="bannerSocialFilesStateService.bannerSocialFilesState().length"
      [gap]="20"
      [visibleItems]="3"
      (currentIndexChange)="onIndexChange($event)"
    >
      <div class="cards">
        @for (file of bannerSocialFilesStateService.bannerSocialFilesState(); track $index) {
          <div
            class="card"
            app-banners-social-file-card
            [file]="file"
            [isEditModeActive]="isEditModeActive"
            [bannerSocialEntityFileType]="bannerSocialEntityFileType()"
            (updateField)="updateField($event)"
          ></div>
        }
        @if (bannerSocialFilesStateService.bannerSocialFilesState().length < 3) {
          <app-file-upload-card
            class="card-upload"
            [fileUploadParams]="{
              recordId: designBlockData().id,
              parentId: designBlockData().id,
              type: bannerSocialEntityFileType(),
              entityFileType: bannerSocialEntityFileType()
            }"
            [isEditModeActive]="isEditModeActive"
            [remainingFileSlots]="remainingFileSlots()"
            (attachFile)="attachFile($event)"
          />
        }
      </div>
    </app-carousel>
  } @else {
    <app-banners-social-file-library
      [isEditModeActive]="isEditModeActive"
      [bannerSocialEntityFileType]="bannerSocialEntityFileType()"
      (getFiles)="getFiles()"
    />
  }
  <div
    class="bottom-modal"
    [class.need-padding-inline]="!isShowFileLibrary()"
    app-banners-social-bottom
    [designBlockData]="designBlockData()"
    [isEditModeActive]="isEditModeActive"
    [isActiveUploadFile]="isActiveUploadFile"
    [bannerSocialEntityFileType]="bannerSocialEntityFileType()"
    (updateComment)="updateComment($event)"
    (attachFile)="attachFile($event)"
  ></div>
</app-base-modal>
